package com.example.monetix.utils

actual fun shareText(text: String, title: String) {
    // JS Share Stub
}
